import store from '../../store/store';
import { resetMember } from './memberSlice';
import { resetGeneral } from '../general/generalSlice';
import { resetAuth } from '../auth/authSlice';
import websocket from '../../lib/websocket';
import { logoutUserApi } from '@/api/userApi';
import syncStoreService from '@/store/syncStore/SyncStoreService';
import { resetLeaderboardsFilters } from '@/state/hypertracker/hypertackerSlice';

export const logoutMember = async (
    withApi: boolean = true,
    onApiLogoutSuccess?: () => void,
): Promise<void> => {
    try {
        if (withApi) {
            await logoutUserApi();
            document.cookie = `isAuth=false; domain=coinmarketman.com`;
            document.cookie = `loggedEnv=; domain=coinmarketman.com`;
        }
    } catch (error) {
        // silent fail for logout api call;
        console.log(error);
    }
    onApiLogoutSuccess?.();
    localStorage.removeItem('lastBannerViewDate');

    websocket.disconnect();
    syncStoreService.resetSyncStore();
    store.dispatch(resetGeneral());
    store.dispatch(resetMember());
    store.dispatch(resetAuth());
    store.dispatch(resetLeaderboardsFilters());
};
